import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login'
import ListeConnect from '@/views/ListeConnect'
import ViewConnect from '@/views/ViewConnect'
import ListeNouvelleDemande from "../views/ListeNouvelleDemande";
import ListeConnectHistory from "../views/ListeConnectHistory";
import ViewTarifier from "../views/ViewTarifier.vue";
import Organisation from "../components/organisation.vue";
import BmciAccueil from "../components/bmciOffers/accueil.vue"
import VivalisAccueil from "../components/vivalisOffers/accueil.vue"
import Stats from "../views/Stats.vue"

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Login',
        component: Login
    },
    {
        path: '/listeConnect',
        name: 'ListeConnect',
        component: ListeConnect,
        meta: { requiredAuth: true }
    },
    {
        path: '/ViewConnect/:id',
        name: 'ViewConnect',
        component: ViewConnect,
        props: true,
        meta: { requiredAuth: true }
    },
    {
        path: '/ListeNouvelleDemande',
        name: 'ListeNouvelleDemande',
        component: ListeNouvelleDemande,
        meta: { requiredAuth: true }
    },
    {
        path: '/ListeConnectHistory',
        name: 'ListeConnectHistory',
        component: ListeConnectHistory,
        props: true,
        meta: { requiredAuth: true }
    },
    {
        path: '/ViewTarifier/:type',
        name: 'ViewTarifier',
        component: ViewTarifier,
        props: true,
        meta: { requiredAuth: true }
    },
    {
        path: '/SimulateurCredit',
        name: 'Organisation',
        component: Organisation,
        props: true,
        meta: { requiredAuth: true }
    },
    {
        path:'/AccueilBmci',
        name: 'BmciAccueil',
        component: BmciAccueil,
        props: true,
        meta: { requiredAuth: true }
    },
    {
        path:'/AccueilVivalis',
        name: 'VivalisAccueil',
        component: VivalisAccueil,
        props: true,
        meta: { requiredAuth: true }
    },
    {
        path:'/Stats',
        name: 'Stats',
        component: Stats,
        props: true,
        meta: { requiredAuth: true }
    }
]

const router = new VueRouter( {
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const loggedIn = localStorage.getItem('user')
    if (to.matched.some(record => record.meta.requiredAuth) && loggedIn == null){
        next({ name: 'Login'})
        return false;
    }
    next()
})

export default router
